module.exports = __webpack_public_path__ + "img/070553f.jpg";